import html2canvas from 'html2canvas';

/**
 * html2canvas 대신 쓰는 캡처 함수. 다크모드여도 PDF·이미지는 항상 밝은 화면으로 찍는다.
 * html2canvas 는 문서를 복제해서 찍으므로, 복제본에서만 .dark 를 떼고 .capture-light(순백 카드)를 붙이면 화면은 그대로 둔 채 밝게 나온다.
 */
export default function html2canvasLight(element, options = {}) {
  const { onclone } = options;
  return html2canvas(element, {
    ...options,
    onclone: (doc, clonedElement) => {
      doc.documentElement.classList.remove('dark');
      doc.documentElement.classList.add('capture-light');
      return onclone ? onclone(doc, clonedElement) : undefined;
    },
  });
}
